import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { IntlShape } from 'react-intl';
import { z } from 'zod';
import { formSchema } from '../schemas';
import { LegacyAutomationSettingsFormInput } from '../types';

const newThresholdErrorMap =
  (intl: IntlShape): z.ZodErrorMap =>
  (issue, ctx) => {
    if (issue.code === 'invalid_type') {
      return {
        message: intl.formatMessage({
          id: 'containers.settings.queues.queue.automation.legacySettings.table.errors.newThresholdInvalidType',
        }),
      };
    }

    if (issue.code === 'too_big' || issue.code === 'too_small') {
      return {
        message: intl.formatMessage({
          id: 'containers.settings.queues.queue.automation.legacySettings.table.errors.newThresholdOutOfRange',
        }),
      };
    }

    return { message: ctx.defaultError };
  };

type UseLegacyAutomationSettingsFormProps = {
  defaultValues: LegacyAutomationSettingsFormInput;
  intl: IntlShape;
};

export const useLegacyAutomationSettingsForm = ({
  defaultValues,
  intl,
}: UseLegacyAutomationSettingsFormProps) => {
  return useForm<LegacyAutomationSettingsFormInput>({
    defaultValues,
    mode: 'onChange',
    resolver: zodResolver(formSchema, {
      errorMap: newThresholdErrorMap(intl),
    }),
  });
};
